import React from 'react';
import { css } from 'emotion';
import { useTheme } from 'emotion-theming';
import Button from 'components/Button/Button';
const ErrorMessage = () => {
    const theme = useTheme();

    const online = navigator.onLine !== false;

    return (
        <div
            className={css`
                display: flex;
                color: ${theme.colours.gray};
                fill: ${theme.colours.gray};
                align-items: center;
                padding: 18px;
            `}
        >
            <div>
                {online ? (
                    <svg viewBox="-72 0 480 480" width={80}>
                        <path d="M100.688 0L0 100.688V480h336V0zM96 27.313V96H27.312zM320 464H16V112h96V16h208zm0 0" />
                        <path d="M126.625 190.055L104 212.687l-22.625-22.632-11.313 11.312L92.689 224l-22.626 22.633 11.313 11.312L104 235.313l22.625 22.632 11.313-11.312L115.313 224l22.624-22.633zm0 0M201.375 257.945L224 235.313l22.625 22.632 11.313-11.312L235.313 224l22.625-22.633-11.313-11.312L224 212.687l-22.625-22.632-11.313 11.312L212.688 224l-22.625 22.633zm0 0M98.344 330.344l11.312 11.312 7.434-7.433c28.137-28.063 73.683-28.063 101.82 0l7.434 7.433 11.312-11.312-7.433-7.434c-34.387-34.308-90.059-34.308-124.446 0zm0 0" />
                    </svg>
                ) : (
                    <svg viewBox="0 0 1024 1280" width={80}>
                        <path d="M279 309.9l13.7 13.7 37.4 37.4 55.3 55.3 67.5 67.5 73.9 73.9 74.6 74.6 69.6 69.6 58.8 58.8 42.3 42.3c6.7 6.7 13.2 13.5 20 20l.9.9 13.2-50.1c-1.8.3-3.7.6-5.5.8 2.7-.4 5.3-.7 8-1.1-23.3 3-47.5 1.6-70.9 1.6H328.5c-18.9 0-37.8.1-56.7 0-9.6 0-19.2-.7-28.7-1.9 2.7.4 5.3.7 8 1.1-19.1-2.6-37.6-7.7-55.3-15.2l7.2 3c-13-5.6-25.5-12.4-37.2-20.4-2.7-1.9-5.4-3.8-8.1-5.8-4.5-3.3 5.9 4.8 1.6 1.2-1.5-1.2-2.9-2.4-4.4-3.6-5.1-4.3-9.9-8.7-14.6-13.4-4.7-4.7-9.1-9.6-13.3-14.7-1.2-1.4-2.6-2.9-3.6-4.4 1 1.3 2 2.5 3 3.8-.6-.8-1.1-1.5-1.7-2.3-2-2.7-3.9-5.4-5.7-8.1-8-11.4-14.5-23.6-19.9-36.4l3 7.2c-7.3-17.6-12.3-36-14.9-54.8.4 2.7.7 5.3 1.1 8-2.4-18.9-2.5-37.9 0-56.8-.4 2.7-.7 5.3-1.1 8 2.6-19.1 7.6-37.7 15-55.5l-3 7.2c5.4-12.8 12-25 19.8-36.5 1.7-2.6 3.5-5.1 5.4-7.6 4.4-6-3.8 4.7-.6.8 1.1-1.4 2.2-2.8 3.4-4.1 4.3-5.1 8.7-10.1 13.4-14.8 4.7-4.7 9.6-9.2 14.7-13.5 1.4-1.1 2.8-2.2 4.1-3.4 3.9-3.1-6.7 5-.8.6 2.5-1.9 5-3.7 7.6-5.4 11.5-7.8 23.7-14.4 36.5-19.9l-7.2 3c10.9-4.6 22.1-8.3 33.6-11.1 5.8-1.4 11.7-2.6 17.7-3.5 10-1.5 18-8.3 22.1-17.3 1.5-3.4 3.1-6.8 4.8-10.1 6.6-13.3 14.2-26.1 22.7-38.3 2.1-3 4.3-6 6.5-9 3.5-4.8-4 5-.5.7 1.2-1.6 2.5-3.1 3.7-4.6 4.9-5.9 10-11.7 15.3-17.2 10.8-11.4 12.1-31.3 0-42.4-11.7-10.8-30.9-12.1-42.4 0-26.1 27.5-48 59.2-63.2 94 6-4.6 12-9.2 17.9-13.8-58.1 8.3-113.8 40-150.7 85.6-19.9 24.6-35.2 51.7-45 82-9.5 29.3-13.3 61.2-10.9 91.9 5.2 64.7 35 126.8 85.1 168.8 45.4 38.1 101.8 59 161.2 59.1h510.5c12.9 0 25.6-1.5 38.2-3.5 10-1.6 18.4-11.7 21-21 2.8-10.3-.2-21.6-7.7-29.2l-13.7-13.7-37.4-37.4-55.3-55.3-67.5-67.5-73.9-73.9-74.6-74.6-69.6-69.6-58.8-58.8-42.3-42.3c-6.7-6.7-13.3-13.5-20-20l-.9-.9c-11.1-11.1-31.5-11.9-42.4 0-11 11.9-11.9 30.5 0 42.3zM402.9 251.2c4.2-2 8.4-3.9 12.7-5.7l-7.2 3c24.5-10.3 50.3-17.3 76.6-20.9-2.7.4-5.3.7-8 1.1 26.6-3.5 53.4-3.5 80 0-2.7-.4-5.3-.7-8-1.1 26.6 3.6 52.5 10.7 77.2 21.1l-7.2-3c13.7 5.9 27 12.7 39.7 20.5 6.5 4 12.9 8.2 19.1 12.7 1.5 1.1 2.9 2.1 4.3 3.2.7.5 1.4 1.1 2.1 1.6 0 0-6.4-5-2.9-2.2 2.8 2.2 5.6 4.5 8.3 6.8 11.4 9.7 22.2 20.2 32.1 31.5 2.2 2.5 4.4 5.1 6.5 7.7 1.1 1.4 2.2 2.8 3.4 4.2 2.8 3.5-2.2-2.9-2.2-2.9.8 1.1 1.6 2.1 2.4 3.2 4.4 5.9 8.6 12 12.6 18.3 9.1 14.3 17 29.4 23.6 45l-3-7.2c8.2 19.5 14.2 39.8 18.2 60.6 1.7 9.2 11.6 19.5 21 21 14.6 2.3 28.7 6.3 42.4 12l-7.2-3c10.8 4.6 21.2 10.1 31 16.6 2.4 1.6 4.8 3.3 7.2 5 1.9 1.4 6.3 5.4-1.3-1 1 .9 2.1 1.7 3.1 2.5 4.5 3.7 8.8 7.6 12.9 11.7s8.1 8.4 11.8 12.9c.9 1 1.7 2.1 2.5 3.1 3.3 4.1-4.3-5.8-1.4-1.8 1.9 2.5 3.7 5.1 5.4 7.7 6.5 9.8 12.1 20.1 16.7 30.9l-3-7.2c6.2 14.9 10.4 30.5 12.6 46.5-.4-2.7-.7-5.3-1.1-8 2.1 16.2 2.1 32.5-.1 48.6.4-2.7.7-5.3 1.1-8-2.2 15.8-6.4 31.2-12.5 45.9l3-7.2c-4.6 10.8-10.1 21.1-16.6 30.9-1.6 2.4-3.2 4.7-4.9 7-1.4 1.9-5.1 5.5.9-1.1-.9 1-1.6 2-2.4 3-3.8 4.6-7.8 9-12 13.2-11.1 11.2-12 31.4 0 42.4 11.9 11 30.6 11.9 42.4 0 23.7-23.9 41.4-52.9 52.1-84.8 10.8-32.1 12.4-66.1 7.7-99.4-8.2-57.4-42.4-108.1-89-141.5-25-17.9-55.1-30.2-85.5-35.1l21 21c-13.5-71.1-52.1-137.9-106.9-185.2-57.5-49.5-129.7-78.4-205.6-81.3-54-2-107.4 10-156.1 33.1-6.5 3.1-12 11.3-13.8 17.9-2 7.2-1.1 16.7 3 23.1 9.7 14.9 26.1 18.3 41.3 11.1z" />
                        <path d="M108.4 139.3l21.1 21.1 57.5 57.5 84.7 84.7L375 405.9 488.1 519l114.6 114.6 106.8 106.8 90 90 64.7 64.7c10.2 10.2 20.4 20.5 30.7 30.7l1.3 1.3c11.1 11.1 31.5 11.9 42.4 0 11-12 11.9-30.6 0-42.4l-21.1-21.1-57.5-57.5-84.7-84.7L672 618.1 558.9 505 444.3 390.4 337.5 283.6l-90-90-64.7-64.7c-10.2-10.2-20.4-20.5-30.7-30.7l-1.3-1.3c-11.1-11.1-31.5-11.9-42.4 0-11 12-11.9 30.6 0 42.4z" />
                    </svg>
                )}
            </div>
            <div
                className={css`
                    margin-left: 18px;
                    margin-top: -5px;
                `}
            >
                <h3
                    className={css`
                        font-weight: bold;
                        font-size: 24px;
                    `}
                >
                    {online ? 'Что-то пошло не так...' : 'Пропал интернет, все пропало! :-('}
                </h3>
                <p>
                    {online ? (
                        <>
                            Кажется у нас все сломалось... Попробуйте еще разок, а если не поможет, напишите нам
                            пожалуйста на{' '}
                            <a
                                className={css`
                                    text-decoration: underline;
                                `}
                                href="mailto:pb@psmb.ru"
                                target="_blank"
                            >
                                pb@psmb.ru
                            </a>
                        </>
                    ) : (
                        'Мы не успели сохранить эту страницу для офлайн доступа, а интернет куда-то пропал... Найдите интернет и попробуйте снова.'
                    )}
                </p>
                <p>
                    <Button
                        className={css`
                            text-decoration: underline;
                            padding: 0;
                            margin-top: 10px;
                        `}
                        onClick={() => {
                            location.reload();
                        }}
                    >
                        Попробовать еще раз
                    </Button>
                </p>
            </div>
        </div>
    );
};

export default ErrorMessage;
